var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocBlueInGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F6F7FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7413 19.1215C16.0892 21.159 17.8634 22.71 20.0001 22.71C22.1368 22.71 23.911 21.159 24.2589 19.1215H24.3517C25.0513 19.1215 25.6184 18.5544 25.6184 17.8549C25.6184 17.1553 25.0513 16.5883 24.3517 16.5883H24.3211V16.1191C22.6151 15.7164 21.5675 14.8116 21.0292 14.2024C20.25 14.8986 18.5571 16.0829 15.6792 16.5738L15.532 16.5938C14.8871 16.6527 14.3818 17.1947 14.3818 17.8549C14.3818 18.5544 14.9489 19.1215 15.6485 19.1215H15.7413Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6797 15.3841C19.1998 14.7288 20.6118 12.967 20.6261 12.9488L21.1642 12.2597L21.597 13.0193C21.6292 13.0742 22.4022 14.3595 24.3216 14.9084V14.3209C24.3216 11.9345 22.387 10 20.0006 10C17.6143 10 15.6797 11.9345 15.6797 14.3209V15.3841Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7095 26.4844H25.5269C24.994 26.4844 24.5605 26.9179 24.5605 27.4507V28.8281H26.6758V27.4507C26.6758 26.9179 26.2423 26.4844 25.7095 26.4844Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3818 28.8281C14.8133 28.8281 15.1631 28.4783 15.1631 28.0469C15.1631 27.6154 14.8133 27.2656 14.3818 27.2656C13.9504 27.2656 13.6006 27.6154 13.6006 28.0469C13.6006 28.4783 13.9504 28.8281 14.3818 28.8281Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4058 23.6985C20.9501 23.8192 20.4776 23.8819 19.9998 23.8819C19.5219 23.8819 19.0495 23.8192 18.5938 23.6985L19.9998 25.6704L21.4058 23.6985Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4286 28.047C12.4286 27.1741 13.0043 26.4332 13.7958 26.1838V22.7122L12.1968 23.4624C10.8623 24.0884 10 25.4454 10 26.9195V30.0001H14.3818C13.3048 30.0001 12.4286 29.1239 12.4286 28.047Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8031 23.4622L26.2041 22.712V25.3709C27.1453 25.5947 27.8477 26.442 27.8477 27.4507V30H30V26.9194C30 25.4453 29.1376 24.0883 27.8031 23.4622Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0324 25.3708V22.1622L24.2922 21.8149C24.1441 22.0005 20.0001 27.6888 20.0001 27.6888C20.0001 27.6888 15.8561 22.0005 15.708 21.8149L14.9678 22.1622V26.1836C15.7593 26.433 16.335 27.1739 16.335 28.0468C16.335 29.1237 15.4588 29.9999 14.3818 29.9999H23.3888V27.4506C23.3888 26.4419 24.0912 25.5946 25.0324 25.3708Z",
    fill: "#4B9BF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocBlueInGrey);
export default __webpack_public_path__ + "static/media/doc-blue-in-grey.1b9ac78db4e01a28051002afb50209d9.svg";
export { ForwardRef as ReactComponent };